import request from '../api';

export const fetchSearch = (city, id) => request('panpartner:block.detail.ajax', 'searchById', { city, id });